/**
 * Subscription Management API service
 * Handles subscription plans, usage tracking, and plan changes
 */

import api from './api';
import type {
  AvailablePlansResponse,
  SubscriptionResponse,
  UsageResponse,
  ChangePlanData,
  ChangePlanResponse,
  PaymentsResponse,
} from '../types';

export const subscriptionService = {
  /**
   * Get all available subscription plans
   */
  async getAvailablePlans(): Promise<AvailablePlansResponse> {
    const response = await api.get<AvailablePlansResponse>('/api/subscription-plans');
    return response.data;
  },

  /**
   * Get current account subscription details
   */
  async getCurrentSubscription(): Promise<SubscriptionResponse> {
    const response = await api.get<SubscriptionResponse>('/api/account/subscription');
    return response.data;
  },

  /**
   * Get account usage statistics
   */
  async getUsage(): Promise<UsageResponse> {
    const response = await api.get<UsageResponse>('/api/account/usage');
    return response.data;
  },

  /**
   * Change subscription plan (owner only)
   * @param data Plan change data containing new plan_id
   */
  async changePlan(data: ChangePlanData): Promise<ChangePlanResponse> {
    const response = await api.post<ChangePlanResponse>('/api/account/subscription/change-plan', data);
    return response.data;
  },

  /**
   * Get payment history for current account
   */
  async getPaymentHistory(): Promise<PaymentsResponse> {
    const response = await api.get<PaymentsResponse>('/api/account/subscription-payments');
    return response.data;
  },
};

export default subscriptionService;
